export function computeSegmentSetbacks(
  segment,
  fireSetbacks,
  setbackMode,
  { forceUpdate = false } = {}
) {
  if (segment?.setbacks && segment.setbacks.length > 0 && !forceUpdate) {
    return { segment, changed: false };
  }

  const lines = Array.isArray(segment?.lines) ? segment.lines : [];
  const setbacks = lines.map((label) => {
    if (setbackMode === 0) {
      return label === 'Eave' ? 0 : fireSetbacks?.general || 0;
    }
    return fireSetbacks?.[label?.toLowerCase()] || 0;
  });

  return {
    segment: { ...segment, setbacks },
    changed: true
  };
}

export function applySetbacks(
  state,
  { fireSetbacks = null, setbackMode = null, forceUpdate = false } = {}
) {
  const nextSetbackMode =
    setbackMode === null || setbackMode === undefined
      ? state.setbackMode
      : setbackMode;
  const nextFireSetbacks = fireSetbacks || state.fireSetbacks;
  let hasChanged = false;

  const segments = (state.segments || []).map((segment) => {
    const result = computeSegmentSetbacks(
      segment,
      nextFireSetbacks,
      nextSetbackMode,
      { forceUpdate }
    );
    if (result.changed) hasChanged = true;
    return result.segment;
  });

  return {
    ...state,
    segments,
    setbackMode: nextSetbackMode,
    fireSetbacks: nextFireSetbacks,
    __setbacksChanged: hasChanged || forceUpdate
  };
}

export function patchFireSetbacks(state, setback, label) {
  const fireSetbacks =
    label === 'general'
      ? {
          ...state.fireSetbacks,
          general: setback,
          eave: setback,
          ridge: setback,
          rake: setback,
          hip: setback,
          valley: setback
        }
      : { ...state.fireSetbacks, [label]: setback };

  return applySetbacks(
    { ...state, fireSetbacks },
    { fireSetbacks, forceUpdate: true }
  );
}

export function patchSegmentSetbacks(state, editLines = [], setback) {
  if (!Array.isArray(editLines) || editLines.length === 0) return state;

  const bySegment = {};
  editLines.forEach(({ seg, line }) => {
    const segmentIndex = Number(seg);
    if (!Number.isFinite(segmentIndex)) return;
    if (!bySegment[segmentIndex]) bySegment[segmentIndex] = {};
    bySegment[segmentIndex][line] = setback;
  });

  const segments = (state.segments || []).map((segment, index) => {
    const linePatches = bySegment[index];
    if (!linePatches) return segment;
    const setbacks = Array.isArray(segment.setbacks)
      ? [...segment.setbacks]
      : [];
    Object.keys(linePatches).forEach((lineKey) => {
      const lineIndex = Number(lineKey);
      if (!Number.isFinite(lineIndex)) return;
      setbacks[lineIndex] = linePatches[lineKey];
    });
    return { ...segment, setbacks };
  });

  return { ...state, segments };
}
